import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {updateCommercialUser} from '../actions/edit';
import {updateNewCommercialUser} from '../actions/create';

const EditableSelectbox = ({
  options,
  row,
  'value': initialValue,
  'column': {'id': columnId},
  uniqueValue,
  width = 'auto',
}) => {
  const [value, setValue] = useState(initialValue);
  const [isEditable, setIsEditable] = useState(false);

  const {modifiedRows, newRows, deletedRows, editableRowIndex} = useSelector((state) => state.commercialUsers);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    setIsEditable((editableRowIndex === row.index));
  }, [editableRowIndex]);

  useEffect(() => {
    if (initialValue === value) {
      return;
    }

    if (newRows[uniqueValue]) {
      return dispatch(updateNewCommercialUser(uniqueValue, {
        [columnId]: value,
      }));
    }

    dispatch(updateCommercialUser(uniqueValue, {
      [columnId]: value,
    }));
  }, [value]);

  let customStyles = {
    width,
  };

  if (newRows[uniqueValue]) {
    customStyles = {
      ...customStyles,
      'backgroundColor': '#a0fc7e',
    };
  } else
  if (deletedRows[uniqueValue]) {
    customStyles = {
      ...customStyles,
      'backgroundColor': '#ff5757',
    };
  } else
  if (modifiedRows[uniqueValue]?.[columnId]) {
    customStyles = {
      ...customStyles,
      'backgroundColor': 'yellow',
    };
  }

  return <select disabled={!isEditable} value={value} onChange={handleChange} style={customStyles}>
    {
      options.map((opt, index) => (
        <option key={index} value={opt.value}>{opt.label}</option>
      ))
    }
  </select>;
};

export default EditableSelectbox;
